import React, { useState } from 'react';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';

const BulkActions = ({ selectedCount, onBulkStatusUpdate, onExport, onBulkDelete }) => {
  const [bulkStatus, setBulkStatus] = React.useState('');

  const statusOptions = [
    { value: '', label: '상태 선택' },
    { value: '주문 접수', label: '주문 접수' },
    { value: '주문완료', label: '주문완료' },
    { value: '픽업 예정', label: '픽업 예정' },
    { value: '세탁 중', label: '세탁 중' },
    { value: '배송 예정', label: '배송 예정' },
    { value: '완료', label: '완료' }
  ];

  const handleBulkUpdate = () => {
    if (bulkStatus) {
      onBulkStatusUpdate(bulkStatus);
      setBulkStatus('');
    }
  };

  return (
    <div className="flex flex-col space-y-3 rounded-lg border border-border bg-muted/30 p-4 sm:flex-row sm:items-center sm:justify-between sm:space-y-0">
      <div className="flex items-center space-x-2">
        <span className="text-sm font-medium text-foreground">
          {selectedCount}개 선택됨
        </span>
      </div>

      <div className="flex flex-col space-y-2 sm:flex-row sm:items-center sm:space-x-3 sm:space-y-0">
        <div className="w-full sm:w-48">
          <Select
            options={statusOptions}
            value={bulkStatus}
            onChange={setBulkStatus}
            placeholder="상태 선택"
          />
        </div>
        <Button
          variant="default"
          size="sm"
          iconName="Check"
          iconPosition="left"
          onClick={handleBulkUpdate}
          disabled={!bulkStatus}
        >
          일괄 변경
        </Button>
        <Button
          variant="outline"
          size="sm"
          iconName="Download"
          iconPosition="left"
          onClick={onExport}
        >
          내보내기
        </Button>
        <Button
          variant="danger"
          size="sm"
          iconName="Trash2"
          iconPosition="left"
          onClick={onBulkDelete}
        >
          선택 삭제
        </Button>
      </div>
    </div>
  );
};

export default BulkActions;